import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FileTypeConstants } from '../../../shared/constants/file-upload-type-constants';
import { FormValidation } from '../../../shared/form-validation';

@Component({
  selector: 'claim-estimate',
  templateUrl: './claim-estimate.component.html',
})
export class ClaimEstimateComponent implements OnInit {

  public claimEstimateForm: UntypedFormGroup;
  public importFiles: File[] = [];
  public acceptedFiles: string[] = [FileTypeConstants.txt, FileTypeConstants.doc, FileTypeConstants.docx, FileTypeConstants.pdf, FileTypeConstants.jpeg, FileTypeConstants.jpg, FileTypeConstants.png, FileTypeConstants.PNG, FileTypeConstants.gif];
  public missingUpload: boolean = true;
  public formCompleted: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.populateData();
  }

  public addImportFiles(filesToImport: File[]) {
    this.importFiles = filesToImport;
    this.missingUpload = false;
  }

  public removeFile(): void {
    this.importFiles = [];
    this.missingUpload = true;
  }

  public populateData() {
    this.claimEstimateForm = new UntypedFormGroup({
      'customerConcern': new UntypedFormControl("", [Validators.required])
    });
  }

  public validateForm(): void {
    //this.missingUpload = this.importFiles.length === 0;
    //this.formCompleted = (FormValidation.isValid(this.claimEstimateForm) && !this.missingUpload);
    this.formCompleted = FormValidation.isValid(this.claimEstimateForm);
  }
}